import { DownloadButtonData } from "@nova/component-export-download-buttons-hover"
import { createFlightpathKML } from "@nova/data-create-flight-path-kml"
import { selectUserLocationShareById } from "features/entity-caching/flights/selectors"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { stageKml } from "features/modals/ExportLayers/module"
import { downloadUriSameOrigin } from "tools/browser/download"
import { fetchTelemetryEvents } from "tools/telemetry/fetchTelemetryEvents"
import { useAppSelector } from "integrations/redux/hooks"
import { UserLocationShareTelemetryEvent } from "features/map/layers/user-locations/userLocationSharePlaybackStore"

export const useUserLocationShareDownloadButtonData = (id: string): DownloadButtonData => {
    const share = useAppSelector(selectUserLocationShareById(id))
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const projectId = useAppSelector(selectActivatedFireId)

    if (!share || !orgId || !projectId) return { exportOptions: {} }

    const shareName = share.name || "Location Share"

    const downloadKml = async () => {
        const { events } = await fetchTelemetryEvents({ orgId, projectId, id })
        const path = (events as UserLocationShareTelemetryEvent[])
            .filter((e): e is UserLocationShareTelemetryEvent => e.type === "locationShare")
            .toSorted((a, b) => a.timestamp - b.timestamp)
            .map((e) => ({
                longitude: e.longitude,
                latitude: e.latitude,
                altitude: e.altitude ?? undefined,
            }))

        const kml = createFlightpathKML(`${shareName} Path`, [path], false)
        const files: { blob: Blob; name: string }[] = []
        stageKml(kml, shareName, files)
        const url = URL.createObjectURL(files[0].blob)
        downloadUriSameOrigin(files[0].name, url)
    }

    return {
        exportOptions: {
            KML: { callback: downloadKml },
        },
    }
}
